import Axios from "./interceptor";
import { appApiBaseUrl } from "./appApiBaseUrl";

const API_URL = appApiBaseUrl + "/api";

const putHIDetails = async (data) => {
  const response = await Axios.post(
    `${API_URL}/CarePlanWizardDetail/UpdateCarePlanInformation`,
    data,
  );
  return response.data;
};

export { putHIDetails };
